import { Component, OnInit, ViewChild, ElementRef, NgZone } from "@angular/core";
import { AngularFireStorage } from "@angular/fire/storage";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Career } from "src/app/interface/career";
import { StudentViewModel } from "src/app/models/student-view-model";
import { AuthService } from "src/app/services/auth.service";
import { ConfigService } from "src/app/services/config.service";
import { StudentService } from "src/app/services/student.service";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import tippy from "tippy.js";
import { Content } from "@angular/compiler/src/render3/r3_ast";
import { animate, animation, state, style, transition, trigger } from "@angular/animations";
import { NotificationService } from "src/app/services/notification.service";
import Push from "push.js";
import { Student } from "src/app/models/student";
import { strict } from "assert";
import { map, switchMap } from "rxjs/operators";
import { BehaviorSubject, Observable, combineLatest, of } from "rxjs";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
@Component({
  selector: "app-mision-control",
  templateUrl: "./mision-control.component.html",
  styleUrls: ["./mision-control.component.css"],
  // animations: [
  //   trigger('fadeIn', [
  //     transition(':enter', [
  //       style({ opacity: 0, transform: 'translateY(-10px)' }),
  //       animate('500ms', style({ opacity: 1, transform: 'translateY(0)' })),
  //     ]),
  //   ]),
  // ],
})
export class MisionControlComponent implements OnInit {
  @ViewChild("userImage") userImage: ElementRef;
  @ViewChild("tooltip") tooltip: ElementRef;
  instance: any;

  careerObjects: Career[];
  ////////////////////filtros de busqueda//////////////
  campusSelected: string;
  careerSelected: string = "all";
  turnSelected: string = "all";
  stateSelected: number = -1;

  campusSelectedList: any[];

  loginCampus: string;
  currentUser: any;

  isRegular: boolean;
  isSabbatine: boolean;
  isDominical: boolean;
  filterSection: FormGroup;
  default: string = "all";
  defaultDate: string = "thisY";

  isAll: boolean = false;
  isDoral: boolean = false;
  isCentral: boolean = false;
  isJinotepe: boolean = false;
  isEsteli: boolean = false;

  ///constantes para la elaboración del archivo

  ///metricas para cantidades de estado
  countPendiente: number = 0;
  countMatriculado: number = 0;
  countRechazado: number = 0;
  countNuevo: number = 0;
  countTotal: number = 0;
  selectedIndex: any;

  constructor(
    public studentService: StudentService,
    public configService: ConfigService,
    public authService: AuthService,
    private _builder: FormBuilder,
    private ngZone: NgZone
  ) {
    ///estraemos el campus del login



    this.filterSection = this._builder.group({
      campus: [""],
      career: [""],
      turn: [""],
      date: [""],
    });


    this.filterSection.controls["turn"].setValue(this.default, {
      onlySelf: true,
    });
    this.filterSection.controls["career"].setValue(this.default, {
      onlySelf: true,
    });
    this.filterSection.controls["campus"].setValue(this.default, {
      onlySelf: true,
    });
    this.filterSection.controls["date"].setValue(this.defaultDate, {
      onlySelf: true,
    });

    this.isDominical = false;
    this.isRegular = false;
    this.isSabbatine = false;

    this.careerObjects = [
      {
        name: "Medicina y Cirugía",
        code: "MD",
        reg: true,
        sab: false,
        dom: false,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Medicina Veterinaria",
        code: "VE",
        reg: true,
        sab: true,
        dom: false,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Enfermería",
        code: "EF",
        reg: true,
        sab: false,
        dom: false,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Farmacia",
        code: "FA",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Psicología",
        code: "PS",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Administración de Empresas",
        code: "AD",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Banca y Finanzas",
        code: "BF",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Contabilidad Pública y Auditoría",
        code: "CT",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Administración Turismo y Hotelería",
        code: "TU",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Mercadotecnia",
        code: "MC",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Derecho",
        code: "DE",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Relaciones Internacionales y Comercio Exterior",
        code: "RI",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Ingeniería en Sistemas",
        code: "IS",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
    ];
    // notification.notificationEvent().subscribe((e) => {
    //   // if (Push.Permission.has()) {
    //   e.forEach((element) => {
    //     if (this.authService.campus === element.campus) {
    //       Push.create("Misión Control", {
    //         body:
    //           "Solicitud de matricula de " +
    //           element.name +
    //           " " +
    //           element.lastname,
    //         icon: "/assets/resources/logoUCN.png",
    //       });
    //     }
    //   });
    //   // }
    // });

    
  }

  isOpen: boolean = false;
  isOpenClose: boolean = false;
  isOpenPopup: boolean = false;
  typePopup: string;

  studentSize: number = 0;
  students: Student[] = [];
  studentsFilter: Student[] = [];
  selectedStudent: Student = {
    id: "",
    name: "",
    lastname: "",
    birthday: new Date(),
    gen: "",
    civil_state: "",
    nacionality_student: "",
    age: 0,
    doc_type: "",
    doc_value: "",
    email: "",
    telHome: "",
    telCellular: "",
    isWA: false,
    country: "",
    country_state: "",
    city: "",
    address: "",
    school_name: "",
    school_type: "",
    school_country: "",
    school_state: "",
    school_city: "",
    school_address: "",
    workplace: "",
    occupation: "",
    urlDiploma: "",
    urlCertificate: "",
    urlCard1: "",
    urlCard2: "",
    urlPhoto: "",
    carrera: "",
    campus: "",
    turn: "",
    rank: "",
    done: true,
    createDate: new Date(),
    lastModifieldDate: new Date(),
    referenceNumber: "",
    stateChange: 0,
    rejectnote: "",
    paystate: false,
    docstate: false,
    contactstate: false,
    log: "",
  };
  studentsReject: number;

  
  ngOnInit(): void {
    const result = combineLatest([this.studentService.currentYear$, this.authService.currentUser$])
    result.pipe(
      switchMap(([currentYear, user]) => {
        return this.getUserData(user).pipe(
          switchMap(campus => this.studentService.getStudentList(campus)),
          map(data => this.setDataFiltering(data))
        );
      })
    ).subscribe(
      () => {
        // Manejar éxito si es necesario
      },
      (error) => {
        console.error('Error:', error);
        // Manejar errores
      }
    );

    // this.studentService.currentYear$
    //  this.authService.currentUser$.pipe(
    //   switchMap((result) => this.getUserData(result)),
    //   switchMap((campus) => this.studentService.getStudentList(campus)))
    //   .subscribe(data => this.setDataFiltering(data))

     
  }

  setDataFiltering(data:any[]){
    this.students = data.map((student)=>({
      ...student
    }))
    this.filteringStudent()
  }

  getUserData(user: any): Observable<string> {
    return new Observable<string>((observer) => {
      this.currentUser = user
      this.loginCampus = this.currentUser.campus
      this.campusSelected = this.currentUser.campus
      observer.next(user.campus)
      observer.complete();
    });
  }
  ngAfterViewInit() {
    this.instance = tippy("#sendWA", {
      content: "Enviar mensaje",
      animation: "scale-subtle",
      arrow: true,
      theme: "translucent",
      placement: "bottom",
    });
    tippy("#sendMail", {
      content: "Enviar correo",
      animation: "scale-subtle",
      arrow: true,
      theme: "translucent",
      placement: "bottom",
    });
  }

  onStudentSelected(item, index) {
    this.selectedIndex = index
    this.selectedStudent = item;
    if (this.students[index].stateChange == 0) {
     
      this.students[index].stateChange = 1;
      const obj = { stateChange: 1 };
      const id = this.students[index].id;
      this.isOpen = true;
      if(this.stateSelected==0){
        this.stateSelected = 1;
        this.selectedIndex = 0
        this.filteringStudent()
      }
      this.onChangeState(id, obj)
    } else {
      this.isOpen = true;
    }
  }

  onChangeState(id, obj) {
    this.ngZone.runOutsideAngular(() => {
      this.studentService.editSavePartial(id, obj).then(() => {
        this.ngZone.run(() => {

        })
      }).catch(error => {
        this.ngZone.run(() => {

        })

      })
    })

  }

  clickClose(): void {
    this.isOpen = false;
  }
  openClose(): void {
    if (this.isOpenClose) {
      this.isOpenClose = false;
    } else {
      this.isOpenClose = true;
    }
    ///este abre el menu de cerrar
  }
  cerrarSesion(): void {
    this.authService.googleLogout();
  }
  questionAccept(): void {
    var userPreference;

    if (confirm("Quieres aceptar las solicitud de matrícula?") == true) {
      userPreference = "Data saved successfully!";
    } else {
      userPreference = "Save Cancelled!";
    }
  }
  load() {
    ///Este método se ejecuta por primera vez al cargar
    this.studentService.getStudent().subscribe((res) => {
      var itemProcessed = 0;
      // console.log(res);
      this.students = [];
      res.forEach((value) => {
        itemProcessed++;
        const data = value;

        const id = value.id;

        const student: StudentViewModel = {
          id: id,
          name: data.name,
          lastname: data.lastname,
          birthday: data.birthday,
          gen: data.gen,
          civil_state: data.civil_state,
          nacionality_student: data.nacionality_student,
          age: data.age,
          doc_type: data.doc_type,
          doc_value: data.doc_value,
          email: data.email,
          telHome: data.telHome,
          telCellular: data.telCellular,
          isWA: data.isWA,
          country: data.country,
          country_state: data.country_state,
          city: data.city,
          address: data.address,
          school_name: data.school_name,
          school_type: data.school_type,
          school_country: data.school_country,
          school_state: data.school_state,
          school_city: data.school_city,
          school_address: data.school_address,
          workplace: data.workplace,
          occupation: data.occupation,
          urlDiploma: data.urlDiploma,
          urlCertificate: data.urlCertificate,
          urlCard1: data.urlCard1,
          urlCard2: data.urlCard2,
          urlPhoto: data.urlPhoto,
          carrera: data.carrera,
          campus: data.campus,
          turn: data.turn,
          rank: data.rank,
          done: data.done,
          createDate: data.createDate.toDate(),
          lastModifieldDate: data.lastModifieldDate.toDate().toLocaleString(),
          referenceNumber: data.referenceNumber,
          stateChange: data.stateChange,
          rejectnote: data.rejectnote,
          paystate: data.paystate,
          docstate: data.docstate,
          contactstate: data.contactstate,
          log: data.log,
        };

        // if (
        //   data.createDate.toDate().getFullYear() === new Date().getFullYear()
        // )
        //if (data.createDate.toDate().getMonth() === new Date().getMonth())
        this.students.push(student);
        // if (itemProcessed === res.length) {
        //   this.students.sort((a, b) => {
        //     var c = new Date(a.createDate.getTime());
        //     var d = new Date(b.createDate.getTime());
        //     return c < d ? 1 : -1;
        //   });
        // }
      });

      if (this.studentSize === 0) {
        this.studentSize = this.students.length;
      } else {
        var size = this.students.length;
        if (size > this.studentSize) {
          this.studentSize = this.students.length;
          if (this.authService.campus === this.students[0].campus) {
            Push.create("Misión Control", {
              body:
                "Solicitud de matricula de " +
                this.students[0].name +
                " " +
                this.students[0].lastname,
              icon: "/assets/resources/logoUCN.png",
            });
          }
        }
      }
      ///el campus que fue asignado al usuario se carga por primera vez al cargar los filtros
      this.campusSelected = this.loginCampus
      this.filteringStudent();
    });
  }

  // loadStudentByFilter(campus: string, carrera: string, turno: string) {
  //   this.studentService
  //     .getStudentByFilter(campus, carrera, turno)
  //     .subscribe((res) => {
  //       var itemProcessed = 0;
  //       this.students = [];
  //       res.forEach((value) => {
  //         const data = value;

  //         const id = value.id;

  //         const student: StudentViewModel = {
  //           id: id,
  //           name: data.name,
  //           lastname: data.lastname,
  //           birthday: data.birthday,
  //           gen: data.gen,
  //           civil_state: data.civil_state,
  //           nacionality_student: data.nacionality_student,
  //           age: data.age,
  //           doc_type: data.doc_type,
  //           doc_value: data.doc_value,
  //           email: data.email,
  //           telHome: data.telHome,
  //           telCellular: data.telCellular,
  //           isWA: data.isWA,
  //           country: data.country,
  //           country_state: data.country_state,
  //           city: data.city,
  //           address: data.address,
  //           school_name: data.school_name,
  //           school_type: data.school_type,
  //           school_country: data.school_country,
  //           school_state: data.school_state,
  //           school_city: data.school_city,
  //           school_address: data.school_address,
  //           workplace: data.workplace,
  //           occupation: data.occupation,
  //           urlDiploma: data.urlDiploma,
  //           urlCertificate: data.urlCertificate,
  //           urlCard1: data.urlCard1,
  //           urlCard2: data.urlCard2,
  //           urlPhoto: data.urlPhoto,
  //           carrera: data.carrera,
  //           campus: data.campus,
  //           turn: data.turn,
  //           rank: data.rank,
  //           done: data.done,
  //           createDate: data.createDate.toDate().toLocaleString(),
  //           lastModifieldDate: data.lastModifieldDate.toDate().toLocaleString(),
  //           referenceNumber: data.referenceNumber,
  //           stateChange: data.stateChange,
  //           rejectnote: data.rejectnote,
  //           paystate: data.paystate,
  //           docstate: data.docstate,
  //           contactstate: data.contactstate,
  //           log: data.log,
  //         };
  //         //if (data.createDate.toDate().getMonth() === new Date().getMonth())
  //         this.students.push(student);
  //         if (itemProcessed === res.length) {
  //           this.students.sort((a, b) => {
  //             var c = new Date(a.createDate.getTime());
  //             var d = new Date(b.createDate.getTime());
  //             return c < d ? 1 : -1;
  //           });
  //         }
  //       });

  //       if (this.studentSize === 0) {
  //         this.studentSize = this.students.length;
  //       } else {
  //         var size = this.students.length;
  //         if (size > this.studentSize) {
  //           console.log("llego uno nuevo");
  //         }
  //       }
  //     });
  // }

  onCampusChange(value: any) {
    var campus = this.filterSection.get("campus").value;
    var career = this.filterSection.get("career").value;
    var turn = this.filterSection.get("turn").value;

    // if (career != "all") {
    //   this.loadStudentByFilter(campus, career, turn);
    // } else {
    //   this.loadStudentByFilter(campus, career, turn);
    // }


    // this.campusSelectedList = [];

    // if (value.target.value == 'central') {
    //   for (let index = 0; index < this.careerObjects.length; index++) {
    //     if (this.careerObjects[index].central) {
    //       this.campusSelectedList.push(this.careerObjects[index]);
    //     }
    //   }
    // } else if (value.target.value == 'doral') {
    //   for (let index = 0; index < this.careerObjects.length; index++) {
    //     if (this.careerObjects[index].doral) {
    //       this.campusSelectedList.push(this.careerObjects[index]);
    //     }
    //   }
    // } else if (value.target.value == 'jinotepe') {
    //   for (let index = 0; index < this.careerObjects.length; index++) {
    //     if (this.careerObjects[index].jinotepe) {
    //       this.campusSelectedList.push(this.careerObjects[index]);
    //     }
    //   }
    // } else if (value.target.value == 'esteli') {
    //   for (let index = 0; index < this.careerObjects.length; index++) {
    //     if (this.careerObjects[index].esteli) {
    //       this.campusSelectedList.push(this.careerObjects[index]);
    //     }
    //   }
    // }
  }
  onChangeCareer(e) {
    var campus = this.filterSection.get("campus").value;
    var career = this.filterSection.get("career").value;
    var turn = this.filterSection.get("turn").value;

    // if (career != "all") {
    //   this.loadStudentByFilter(campus, career, turn);
    // } else {
    //   this.loadStudentByFilter(campus, career, turn);
    // }

    // this.careerSelected = e.target.value;
    // this.careerObjects.forEach(element => {
    //   if(element.name === career.name){
    //     this.isRegular = element.reg;
    //     this.isSabbatine = element.sab;
    //     this.isDominical = element.dom;

    //   }

    // });

    // console.log(this.careerSelected)

    //this.loadStudentByFilter(campus, career.name, turn);
  }
  onChangeTurn() {
    var campus = this.filterSection.get("campus").value;
    var career = this.filterSection.get("career").value;
    var turn = this.filterSection.get("turn").value;
    //this.loadStudentByFilter(campus, career.name, turn);
    // if (career != "all") {
    //   this.loadStudentByFilter(campus, career, turn);
    // } else {
    //   this.loadStudentByFilter(campus, career, turn);
    // }


  }

  ///exportar a excel
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  exportAsXLSX(): void {
    //this.exportAsExcelFile(this.students, "sample");
  }

  sendMessage(waNumer: String): void {
    window.open(`https://api.whatsapp.com/send?phone=${waNumer}`, "_blank");
  }
  sendMail(selectedEmail: String): void {
    window.location.href = `mailto:${selectedEmail}`;
  }

  openConfirmation() {
    this.isOpenPopup = true;
    this.typePopup = "confirmation";
  }
  openReject() {
    this.isOpenPopup = true;
    this.typePopup = "reject";
  }

  changeContent(numero: string) {
    this.instance[0].setContent(numero);
  }

  onChangefilter() {
    this.campusSelected = this.filterSection.get("campus").value;
    this.careerSelected = this.filterSection.get("career").value;
    this.turnSelected = this.filterSection.get("turn").value;
    this.filteringStudent();
  }
  filteringStudent() {
    var filter = this.students
      .filter((e) => {
        return this.campusSelected != "all" ? e.campus === this.campusSelected : e;
      })
      .filter((e) => {
        return this.careerSelected != "all" ? e.carrera === this.careerSelected : e;
      })
      .filter((e) => {
        return this.turnSelected != "all" ? e.turn === this.turnSelected : e;
      })
      .filter((e) => {
        return this.stateSelected != -1 ? e.stateChange == this.stateSelected : e;
      })

      var filterWithout = this.students
      .filter((e) => {
        return this.campusSelected != "all" ? e.campus === this.campusSelected : e;
      })
      .filter((e) => {
        return this.careerSelected != "all" ? e.carrera === this.careerSelected : e;
      })
      .filter((e) => {
        return this.turnSelected != "all" ? e.turn === this.turnSelected : e;
      })

    this.countNuevo = filterWithout.filter(e => e.stateChange == 0).length
    this.countPendiente = filterWithout.filter(e => e.stateChange == 1).length
    this.countMatriculado = filterWithout.filter(e => e.stateChange == 8).length
    this.countRechazado = filterWithout.filter(e => e.stateChange == 3).length

    this.studentsFilter = filter;

  }



  convertAsDate(timestamp: any) {

    if (new Date(timestamp).getTime() > 0) {
      return new Date(timestamp).toLocaleDateString('es-es');
    } else {
      return this.formatDate(timestamp)
    }
  }
  formatDate(objetoFecha: any): string | null {
    if (!objetoFecha || typeof objetoFecha !== 'object' || objetoFecha.seconds === undefined) {
      return null;
    }
    const fechaMilisegundos = objetoFecha.seconds * 1000;
    const fecha = new Date(fechaMilisegundos);

    if (isNaN(fecha.getTime())) {
      return null;
    }

    return fecha.toLocaleString(); // Formatea la fecha como una cadena legible
  }


  onChangeStateTab(state: number) {
    this.stateSelected = state;
    this.selectedIndex = -1;
    this.filteringStudent()
  }

  onChangeYearNext() {
    if ((this.studentService.currentYear + 1) <= this.studentService.getCurrentYear()) {
      const year = this.studentService.currentYear;
      this.studentService.setCurrentYear(year+1)
    }
  }
  onChangeYearPrev() {
    const year = this.studentService.currentYear;
    this.studentService.setCurrentYear(year-1)

  }





}
